import { history } from '../util/init';
import { navigateTo } from '../util/navigation';
import actionTypes from '../constants/action-types';
import steps from '../constants/step-constants';

export const navigateSignin = () => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_APP,
  });

  navigateTo('/');
};
export const clearPaymentError = () => (dispatch) => {
  // Clear error on review screen from Payment Declined in case the user changes the card
  dispatch({ type: actionTypes.CLEAR_PAYMENT_ERROR });
};

export const navigateInvoiceDetails = () => (dispatch) => {
  dispatch({
    type: actionTypes.UPDATE_STEP,
    activeStep: steps.INVOICE_DETAILS,
    isSignInComplete: true,
  });
};

export const navigateToPayment = () => (dispatch) => {
  dispatch({
    type: actionTypes.UPDATE_STEP,
    activeStep: steps.PAYMENT,
    isInvoiceComplete: true,
  });

  dispatch(clearPaymentError());
};

export const navigateToReview = () => (dispatch) => {
  dispatch({
    type: actionTypes.UPDATE_STEP,
    activeStep: steps.REVIEW,
    isPaymentComplete: true,
  });

  dispatch(clearPaymentError());
};

export const goToStep = (selectedStep) => (dispatch, getState) => {
  const { step } = getState();
  let isStepEnabled = false;
  const isPaymentSuccess = window.location.href.includes('payment-success');

  // Flesh out validation here
  if (selectedStep === steps.LANDING) {
    // For now, do not allow the user to return to this page. Consider adding a start over button
    isStepEnabled = false;
  } else if (selectedStep === steps.INVOICE_DETAILS && step.isSignInComplete) {
    isStepEnabled = true;
  } else if (selectedStep === steps.PAYMENT && step.isInvoiceComplete) {
    isStepEnabled = true;
  } else if (selectedStep === steps.REVIEW && step.isPaymentComplete) {
    isStepEnabled = true;
  }
  if (isPaymentSuccess) {
    history.replace('/');
  }

  if (isStepEnabled) {
    dispatch(clearPaymentError());
    dispatch({
      type: actionTypes.UPDATE_STEP,
      activeStep: selectedStep,
    });
  }
};
